import { account } from './account';
import { addGiftCard } from './add-gift-card';
import { addresses } from './addresses';
import { bag } from './bag';
import { challenges } from './challenges';
import { checkout } from './checkout';
import { creditCardForm } from './credit-card-form';
import { date } from './date';
import { delivery } from './delivery';
import { dietaryRestrictions } from './dietary-restrictions';
import { errors } from './errors';
import { floatingButtons } from './floating-buttons';
import { footer } from './footer';
import { forcedAppUpdate } from './forced-app-update';
import { forgotPassword } from './forgot-password';
import { form } from './form';
import { general } from './general';
import { home } from './home';
import { join } from './join';
import { joinVerification } from './join-verification';
import { location } from './location';
import { login } from './login';
import { menu } from './menu';
import { menuCollection } from './menu-collection';
import { menuPersonalization } from './menu-personalization';
import { navbar } from './navbar';
import { notFoundView } from './not-found-view';
import { orderCancellation } from './order-cancellation';
import { orderProduct } from './order-product';
import { orderStatusInfo } from './order-status-info';
import { orderStatus } from './order-status';
import { pageTitles } from './page-titles';
import { personalData } from './personal-data';
import { product } from './product';
import { rateOrder } from './rate-order';
import { reorder } from './reorder';
import { scanInStore } from './scan-in-store';
import { scanToPay } from './scan-to-pay';
import { signedOutView } from './signed-out-view';
import { sweetpass } from './sweetpass';
import { sweetpassMembership } from './sweetpass-membership';
import { redeemGiftCardForm } from './redeem-gift-card-form';

export const enUs = {
  ...general,
  ...date,
  ...account,
  ...addGiftCard,
  ...addresses,
  ...bag,
  ...checkout,
  ...creditCardForm,
  ...delivery,
  ...home,
  ...menu,
  ...menuCollection,
  ...menuPersonalization,
  ...location,
  ...login,
  ...join,
  ...product,
  ...personalData,
  ...challenges,
  ...navbar,
  ...errors,
  ...footer,
  ...form,
  ...dietaryRestrictions,
  ...forgotPassword,
  ...joinVerification,
  ...orderCancellation,
  ...orderStatusInfo,
  ...orderStatus,
  ...pageTitles,
  ...rateOrder,
  ...redeemGiftCardForm,
  ...reorder,
  ...scanInStore,
  ...scanToPay,
  ...sweetpass,
  ...sweetpassMembership,
  ...notFoundView,
  ...signedOutView,
  ...orderProduct,
  ...forcedAppUpdate,
  ...floatingButtons,
};

// We only need the keys from en-US since we
// are making the assumption that all languages
// will be using the same keys in this early
// naive implementation
export type TranslationKeys = keyof typeof enUs;
